import { createGlobalStyle } from "styled-components";

import HalvarBreit_Lt_woff from "../fonts/HalvarBreit-Lt.woff"; // Light
import HalvarBreit_Lt_woff2 from "../fonts/HalvarBreit-Lt.woff2";

import HalvarBreit_Rg_woff from "../fonts/HalvarBreit-Rg.woff"; // Regular
import HalvarBreit_Rg_woff2 from "../fonts/HalvarBreit-Rg.woff2";

import HalvarBreit_Md_woff from "../fonts/HalvarBreit-Md.woff"; // Medium
import HalvarBreit_Md_woff2 from "../fonts/HalvarBreit-Md.woff2";

import HalvarBreit_Bd_woff from "../fonts/HalvarBreit-Bd.woff"; // Bold
import HalvarBreit_Bd_woff2 from "../fonts/HalvarBreit-Bd.woff2";

import HalvarBreit_Blk_woff from "../fonts/HalvarBreit-Blk.woff"; // Black
import HalvarBreit_Blk_woff2 from "../fonts/HalvarBreit-Blk.woff2";

import HalvarBreit_XBd_woff from "../fonts/HalvarBreit-XBd.woff"; // ExtraBold
import HalvarBreit_XBd_woff2 from "../fonts/HalvarBreit-XBd.woff2";

const FontsStyle = createGlobalStyle`
    @font-face {
        font-family: "Halvar Breit";
        src: url(${HalvarBreit_Lt_woff2}) format("woff2"),
            url(${HalvarBreit_Lt_woff}) format("woff");
        font-weight: 300;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: "Halvar Breit";
        src: url(${HalvarBreit_Rg_woff2}) format("woff2"),
            url(${HalvarBreit_Rg_woff}) format("woff");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: "Halvar Breit";
        src: url(${HalvarBreit_Md_woff2}) format("woff2"),
            url(${HalvarBreit_Md_woff}) format("woff");
        font-weight: 500;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: "Halvar Breit";
        src: url(${HalvarBreit_Bd_woff2}) format("woff2"),
            url(${HalvarBreit_Bd_woff}) format("woff");
        font-weight: bold;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: "Halvar Breit";
        src: url(${HalvarBreit_Blk_woff2}) format("woff2"),
            url(${HalvarBreit_Blk_woff}) format("woff");
        font-weight: 800;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: "Halvar Breit";
        src: url(${HalvarBreit_XBd_woff2}) format("woff2"),
            url(${HalvarBreit_XBd_woff}) format("woff");
        font-weight: 900;
        font-style: normal;
        font-display: swap;
    }
`;

export default FontsStyle;
